import React from 'react';
import { Statistic } from 'antd';
import { ShopOutlined, EnvironmentOutlined, AppstoreOutlined } from '@ant-design/icons';
import { StatsContainer, StatCard } from '../styles';
import type { StoreStatsProps } from '../types';

const StoreStats: React.FC<StoreStatsProps> = ({ stores }) => {
  const totalStores = stores.length;
  const storesWithAddress = stores.filter((store) => store.address).length;
  const categorizedStores = stores.filter(
    (store) => store.categories && store.categories.length > 0
  ).length;

  return (
    <StatsContainer>
      <StatCard>
        <Statistic
          title="Total Stores"
          value={totalStores}
          prefix={<ShopOutlined />}
          valueStyle={{ color: '#1890ff' }}
        />
      </StatCard>
      <StatCard>
        <Statistic
          title="With Address"
          value={storesWithAddress}
          prefix={<EnvironmentOutlined />}
          valueStyle={{ color: '#52c41a' }}
        />
      </StatCard>
      <StatCard>
        <Statistic
          title="Categorized"
          value={categorizedStores}
          prefix={<AppstoreOutlined />}
          valueStyle={{ color: '#722ed1' }}
        />
      </StatCard>
    </StatsContainer>
  );
};

export default React.memo(StoreStats);
